import { Stack } from '@mui/material';
import { FlowGetNotableObjectProviderIdType } from 'flow-schema';

import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockSelectField } from '../../../ConfigFields/SelectField';
import { BlockSwitchField } from '../../../ConfigFields/Switch';
import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField';

export function ProviderFormFields() {
  const { value: isSelectMultipleProviderIdsEnabled } = useSelectedNodeField<boolean>(
    'config.isSelectMultipleProviderIdsEnabled'
  );

  return (
    <>
      <Stack direction="column" spacing={2}>
        <BlockSelectField
          fieldName="config.providerIdType"
          label="Provider ID Type"
          options={Object.entries(FlowGetNotableObjectProviderIdType).map(([key, value]) => ({
            label: key,
            value,
          }))}
          required
        />
        <BlockSwitchField
          fieldName="config.isSelectMultipleProviderIdsEnabled"
          label="Select Multiple Provider IDs"
          helperText="If enabled, multiple provider IDs can be selected."
        />
        <BlockValueTemplateField
          fieldName="config.providerId"
          label="Provider ID(s)"
          helperText={
            isSelectMultipleProviderIdsEnabled
              ? 'Multiple provider IDs required.'
              : 'Single provider ID required.'
          }
        />
      </Stack>
    </>
  );
}
